export default {
  report_id_label: "报告ID",
  report_id_placeholder: "输入报告ID进行搜索",
  type_label: "类型",
  type_placeholder: "选择类型",
  shared_label: "已分享",
  shared_placeholder: "选择分享状态",
  report_id: "报告ID",
  date: "日期",
  report_type: "报告类型",
  created_at: "创建时间",
  shared: "已分享",
  actions: "操作",
  view_count: "浏览次数",
  regenerate: "重新生成",
  delete_confirm: "确定要删除此报告吗？",
  copied: "链接已复制到剪贴板",
  copied_with_expire: "链接已复制到剪贴板，将于{date}过期",
  copy_failed: "复制链接失败",
  share_failed: "分享失败",
  report_detail: "报告详情",
  preview_title: "报告预览",
  data_format_error: "数据格式错误",
  plan_changed_notice: "您的套餐已变更，现在使用最新套餐({planType})查看此报告。",
  config_changed_notice: "您的配置已变更，现在使用最新配置查看此报告。",
  calculation_deleted_notice: "部分计算已被删除。",
  delete_success: "删除成功",
  not_found_title: "报告未找到",
  not_found_desc: "您查找的报告不存在",
  share: "分享",
  copy_link: "复制链接",
  share_to_x: "分享到X",
  share_to_linkedin: "分享到LinkedIn",
  unshare: "取消分享",
  unshare_success: "报告取消分享成功",
  unshare_failed: "取消分享报告失败",
  shared_expires_at: "分享过期时间",
  privacy_fields_hidden: "默认隐藏隐私字段，可在设置-报告配置中修改，更改立即生效",
  want_to_calculate: "想要计算您自己的CBAM碳税吗？首次计算后获得50次计算额度",
  register_free: "免费注册",
  use_invitation_code: "使用邀请码",
  failed_to_load_shared_report: "加载分享报告失败",
  report_data_missing: "报告数据缺失",
  unable_to_get_shared_report: "无法获取分享报告数据",
  carbon_emission_report: "碳排放报告",
  check_out_carbon_emission: "查看此碳排放报告",
};
